import type {QueuedMessage} from '../../../agentChat/queue';

export interface QueueRowRecall {
  imageCount: number;
  canRecall: boolean;
}

/**
 * queueRowRecall derives a queued row's attachment count and whether recall is
 * offered. Recall is hidden for a missing or mid-send item.
 */
export function queueRowRecall(
  item: QueuedMessage | undefined
): QueueRowRecall {
  const imageCount = item?.content.filter(p => p.type === 'image').length ?? 0;
  const canRecall = item != null && !item.draining;
  return {imageCount, canRecall};
}

/**
 * canQueueRowSteer reports whether a row offers force-send. Steer is disabled
 * for a missing or mid-send item, and while any steer on the queue is still
 * pending its cancel, so only one force-send runs at a time.
 */
export function canQueueRowSteer(
  item: QueuedMessage | undefined,
  steerPending: boolean
): boolean {
  return item != null && !item.draining && !steerPending;
}
